/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './menuBtn.less';
import { MenuI } from 'src/pages/store/modules/layout';
import RouteUtils from 'src/util/routeUtils';
import RoleConfigApi from 'src/pages/systemConfig/roleConfig/api/roleConfigApi';
import { isNull } from 'util';
let bem = createBEM('menu-btn');

export interface MenuBtnPropsI {
    menus?: MenuI;
    // 有的时候是个详情页需要传入一个matchPath便是他的主页面的路径
    matchPath?: string
    value?: MenuI;
    showBack?: boolean
    onInput?(menu:MenuI):void
}

@Component
export default class MenuBtn extends Vue.Component<MenuBtnPropsI> {
    @Prop({
        type: Object,
    })
    menus!: MenuI;

    @Prop({
        type: String,
    })
    matchPath!: string;

    @Prop({
        type: Object,
    })
    value!: MenuI;

    @Prop({
        type: Boolean,
    })
    showBack!: boolean;

    zoom!: boolean = true; //缩放图标状态

    @Prop({
        type: Boolean,
        default: false,
    })
    showZoom!: boolean; //缩放图标是否显示

    authorityMenusMap: any = {}

    get currentPageMenu(): MenuI {
        if (this.menus) {
            return this.menus;
        }
        let quene = [...this.$store.state.layout.menus];
        while (quene.length > 0) {
            let menu = quene.shift();
            if (menu.children && menu.children.length > 0) {
                // 有的时候是个详情页需要传入一个matchPath便是他的主页面的路径
                if (menu.children.some(i => i.path === (this.matchPath||this.$route.path))) {
                    let newMenu = {...menu}
                    newMenu.children = newMenu.children.filter(i=> this.authorityMenusMap[i.path] && !i.path.includes("dataManage/dataView/list")
                    && !i.path.includes("/detection/station/list")
                    );
                    return newMenu;
                } else {
                    quene.push.apply(quene, menu.children);
                }
            }
        }
        return { title: '', id: null, path: '', children: [] };
    }
    get activeMenu() {
        if(this.menus) {
           return this.value
        } else {
            return this.currentPageMenu.children!.find(i=>i.path === (this.matchPath||this.$route.path))
        }
    }
    click(menu: MenuI) {
        if(this.menus) {
            this.$emit('input', menu)
        } else {
            if(menu.path == "/water/dataManage/dataView/detail" || 
            menu.path == "/water/dataManage/dataAudit/index"||menu.path == "/water/dataManage/dataComplete/index" ||
            menu.path == "/pollution/dataManage/dataView/detail" || 
            menu.path == "/pollution/dataManage/dataAudit/index"||menu.path == "/pollution/dataManage/dataComplete/index" ||
            menu.path == "/undergroundWater/dataManage/dataView/detail" || 
            menu.path == "/undergroundWater/dataManage/dataAudit/index"||menu.path == "/undergroundWater/dataManage/dataComplete/index")
            {
                RouteUtils.goToWidthCache(menu.path, { mn: this.$route.query.mn,productId: this.$route.query.productId,
                name:this.$route.query.name, id: this.$route.query.id, cn: this.$route.query.cn, is_auto_audit: this.$route.query.is_auto_audit });
            }
            else if(menu.path == "/water/detection/station/detail" || menu.path == "/water/detection/station/trendsManage"
            || menu.path == "/water/detection/station/stateParameter" || menu.path == "/water/detection/station/runLog" ||
            menu.path == "/water/detection/station/alarmLog" || menu.path == "/water/detection/station/parameterLog" ||
            menu.path == "/water/detection/station/video" || menu.path == "/water/detection/station/deviceCounter" ||
            menu.path == "/water/detection/station/deviceDetail" || menu.path == "/water/detection/station/alarmupper" ||
            menu.path == "/pollution/detection/station/detail" || menu.path == "/pollution/detection/station/trendsManage"
            || menu.path == "/pollution/detection/station/stateParameter" || menu.path == "/pollution/detection/station/runLog" ||
            menu.path == "/pollution/detection/station/alarmLog" || menu.path == "/pollution/detection/station/parameterLog" ||
            menu.path == "/pollution/detection/station/video" || menu.path == "/pollution/detection/station/deviceCounter" ||
            menu.path == "/pollution/detection/station/deviceDetail" || menu.path == "/pollution/detection/station/alarmupper" ||
            menu.path == "/undergroundWater/detection/station/detail" || menu.path == "/undergroundWater/detection/station/trendsManage"
            || menu.path == "/undergroundWater/detection/station/stateParameter" || menu.path == "/undergroundWater/detection/station/runLog" ||
            menu.path == "/undergroundWater/detection/station/alarmLog" || menu.path == "/undergroundWater/detection/station/parameterLog" ||
            menu.path == "/undergroundWater/detection/station/video" || menu.path == "/undergroundWater/detection/station/deviceCounter" ||
            menu.path == "/undergroundWater/detection/station/deviceDetail" || menu.path == "/undergroundWater/detection/station/alarmupper")
            {
                RouteUtils.goToWidthCache(menu.path, { mn: this.$route.query.mn,productId: this.$route.query.productId,
                id: this.$route.query.id, factorset: this.$route.query.factorset, type: this.$route.query.type, tag:this.$route.query.tag});
            }
            else
            {
                RouteUtils.goTo(menu.path);
            }
        }
    }
    async mounted() {
        let { code, data } = await RoleConfigApi.queryMenus();
        if (code === 0) {
            let authorityMenusMap: { [str: string]: boolean } = {}
            data.forEach(i => {
                authorityMenusMap[i.power_url] = true
            })
            this.authorityMenusMap = authorityMenusMap
        }
    }
    zoomFlag() {
        this.zoom = !this.zoom
        this.$emit('zoomFlag', this.zoom)
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')} v-if={this.currentPageMenu.children!.length > 0}>
                    {this.currentPageMenu.title}
                </div>
                {this.currentPageMenu.children!.map(i => {
                    return (
                        <div class={bem('item', {'active': this.activeMenu===i})} onClick={this.click.bind(this, i)}>
                            {i.title}
                        </div>
                    );
                })}
                <img v-if={this.showZoom === true && this.zoom === true} class={bem('back')} style="width: 42px;" src={require('../../../assets/images/放大.png')} onClick={this.zoomFlag} />
                <img v-if={this.showZoom === true && this.zoom === false} class={bem('back')} style="width: 42px;" src={require('../../../assets/images/缩小.png')} onClick={this.zoomFlag} />
                {/* <div v-if={this.showBack} class={bem('back')} onClick={() => RouteUtils.goBack()}>返回</div> */}
            </div>
        );
    }
}
